import React from "react";
import AppRouter from "./components/router/AppRouter";
import ThemeProvider from "./theme";
import ErrorBoundary from "components/router/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
     </ErrorBoundary> 
  );
}

export default App;

// import React from "react";
// import Router from "./containers/router/routerCont";
// import {
//   ThemeProvider,
//   StyledEngineProvider,
//   createTheme,
//   adaptV4Theme,
// } from "@mui/material/styles";
// export default class App extends React.Component {
//   render() {
//     return (
//       <>
//         <StyledEngineProvider injectFirst>
//           <ThemeProvider theme={theme}>
//             <Router />
//           </ThemeProvider>
//         </StyledEngineProvider>
//       </>
//     );
//   }
// }
// const theme = createTheme(
//   adaptV4Theme({
//     typography: {
//       fontFamily: ["poppins", "sans-serif"].join(","),
//     },
//   })
// );

// */
